// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-pages{padding-top:120px}.empty-pages .empty-box{display:flex;justify-content:center;align-items:center;flex-direction:column;padding:16px}.empty-pages .empty-box .image-logo{max-width:120px}.empty-pages .empty-box .empty-text{display:block;color:#666;padding-top:16px}", ""]);
// Exports
module.exports = exports;
